{
    "addFromLibrary": "Add From Library",
    "uploadFile": "Upload PDF-file",
    "name": "Name",
    "description": "Description",
    "actions": "actions",
    "attachmentLibrary": "Attachment Library",
    "search": "Search",
    "preview": "Preview",
    "back": "Back",
    "save": "Save",
    "moveDown": "Move down",
    "moveUp": "Move up",
    "delete": "Delete",
    "unselectAllAttachments": "Unselect all attachments",
    "selectAllAttachments": "Select all attachments",
    "unselectAttachment": "Unselect attachment",
    "selectAttachment": "Select attachment",
    "previewAttachment": "Preview attachment"
}